import Vue from 'vue';
import { VuexBuilder } from '@helpers/vuexBuilder';

const state = {
	assetConfiguration: null,
	assetConfiguration_loaded: false,
	locations: [],
	categories: [],
	operations: {
		get: false,
		upsertLocation: false,
		deleteLocation: false,
		upsertCategory: false,
		deleteCategory: false
	}
};

const getters = {
	locations: state => {
		return state.locations;
	},
	categories: state => {
		return state.categories;
	},
	isSaving: state => {
		return state.operations.deleteCategory || state.operations.deleteLocation || state.operations.upsertLocation || state.operations.upsertCategory;
	},
    hasLoaded: state => {
		return state.assetConfiguration_loaded;
	},
};

const actions = {
	async get({ commit, rootState }) {
		return await new VuexBuilder(commit)
			.request(() => Vue.axios.get(`/api/${rootState.tenantId}/assetConfiguration`))
			.operationKey("get")
			.commitData('GET_SUCCESS')
			.execute()
	},
	async deleteLocation({ commit, rootState }, id) {
		return await new VuexBuilder(commit)
			.request(() => Vue.axios.delete(`/api/${rootState.tenantId}/assetConfiguration/locations/${id}`))
			.operationKey("deleteLocation")
			.successToast("Asset location successfully deleted")
			.errorToast("Failed to delete asset location")
			.commitData('REMOVE_LOCATION', id)
			.execute()
	},
	async deleteCategory({ commit, rootState }, id) {
		return await new VuexBuilder(commit)
			.request(() => Vue.axios.delete(`/api/${rootState.tenantId}/assetConfiguration/categories/${id}`))
			.operationKey("deleteCategory")
			.successToast("Asset category successfully deleted")
			.errorToast("Failed to delete asset category")
			.commitData('REMOVE_CATEGORY', id)
			.execute()
	},
	async upsertAssetLocation({commit, rootState}, upsertDto) {
		return await new VuexBuilder(commit)
			.request(() => Vue.axios.post(`/api/${rootState.tenantId}/assetConfiguration/locations`, upsertDto))
			.operationKey("upsertLocation")
			.successToast("Asset location successfully saved")
			.errorToast("Failed to save asset location")
			.commitData('UPSERT_LOCATION')
			.execute()
	},
	async upsertAssetCategory({commit, rootState}, upsertDto) {
		return await new VuexBuilder(commit)
			.request(() => Vue.axios.post(`/api/${rootState.tenantId}/assetConfiguration/categories`, upsertDto))
			.operationKey("upsertCategory")
			.successToast("Asset category successfully saved")
			.errorToast("Failed to save asset category")
			.commitData('UPSERT_CATEGORY')
			.execute()
	},
};

const mutations = {
	START_OPERATION(state, operationKey) {
		state.operations[operationKey] = true
	},
	FINISH_OPERATION(state, operationKey) {
		state.operations[operationKey] = false
	},
	GET_SUCCESS(state, data) {
		state.assetConfiguration_loaded = true;
		state.assetConfiguration = data;
		state.locations = data.locations
		state.categories = data.categories
	},
	UPSERT_LOCATION(state, location) {
		const foundIdx = state.locations.findIndex(x => x.id === location.id)
		if (foundIdx === -1)
			state.locations.push(location)
		else
			state.locations.splice(foundIdx, 1, location)

	},
	REMOVE_LOCATION(state, locationId) {
		const foundIdx = state.locations.findIndex(x => x.id === locationId)
		if (foundIdx !== -1) {
			state.locations.splice(foundIdx, 1)
		}
	},
	UPSERT_CATEGORY(state, category) {
		const foundIdx = state.categories.findIndex(x => x.id === category.id)
		if (foundIdx === -1)
			state.categories.push(category)
		else
			state.categories.splice(foundIdx, 1, category)

	},
	REMOVE_CATEGORY(state, categoryId) {
		const foundIdx = state.categories.findIndex(x => x.id === categoryId)
		if (foundIdx !== -1) {
			state.categories.splice(foundIdx, 1)
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
